<!--我的报价：按账号查询，多张子表以 Excel 样式（行转列）堆叠展示-->
<template>
    <div class="ctrl-wrap" style="padding:20px; width:100%; box-sizing:border-box;">

            <el-card shadow="never" style="margin-bottom: 14px;">
                    <el-form inline>
                        <el-row :gutter="10">
                            <el-col :span="6">
                                <el-form-item :label="msg('结算账号')" style="margin-bottom:0;">
                                    <el-input v-model="query.username" :placeholder="msg('请输入结算账号')"
                                        clearable size="small"
                                        @keyup.enter.native="load">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-button type="primary" icon="el-icon-search" size="small" @click="load">{{msg('查询')}}</el-button>
                            </el-col>
                            <el-col :span="14" v-if="offer && offer.name">
                                <span class="xlabel" style="margin-right:6px;">{{msg('来源报价')}}：</span>
                                <span class="xtext">{{offer.name}}
                                    <span v-if="offer.used===1||offer.used==='1'" class="xsmall">(默认报价)</span>
                                </span>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-card>

                <!-- 报价内容区：仅纵向滚动 -->
                <div class="table-wrap" :style="{maxHeight: docHeight + 'px', overflowY: 'auto', overflowX: 'auto'}">
                    <div style="min-width: 1920px;">

        <!-- 运费 -->
        <section v-if="pivots.freight.headers.length" style="margin-bottom:20px;">
            <h2 class="xtitle">{{msg('运费报价')}}</h2>
            <table class="xtable">
                <thead>
                    <tr>
                        <th>{{msg('结算账号')}}</th>
                        <th v-for="h in pivots.freight.headers" :key="'fh-'+h">{{h}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{query.username}}</td>
                        <td v-for="h in pivots.freight.headers" :key="'fc-'+h">{{pivots.freight.cells[h]}}</td>
                    </tr>
                </tbody>
            </table>
        </section>

        <!-- 派件费：4种维度 -->
        <section v-if="pivots.deliveryTwdStore.headers.length" style="margin-bottom:20px;">
            <h2 class="xtitle">{{msg('店配派件费')}} (TWD)</h2>
            <table class="xtable">
                <thead><tr>
                    <th>{{msg('结算账号')}}</th>
                    <th v-for="h in pivots.deliveryTwdStore.headers" :key="h">{{h}}</th>
                </tr></thead>
                <tbody><tr>
                    <td>{{query.username}}</td>
                    <td v-for="h in pivots.deliveryTwdStore.headers" :key="h">{{pivots.deliveryTwdStore.cells[h]}}</td>
                </tr></tbody>
            </table>
        </section>

        <section v-if="pivots.deliveryTwdOffline.headers.length" style="margin-bottom:20px;">
            <h2 class="xtitle">{{msg('线下派件费')}} (TWD)</h2>
            <table class="xtable">
                <thead><tr>
                    <th>{{msg('结算账号')}}</th>
                    <th v-for="h in pivots.deliveryTwdOffline.headers" :key="h">{{h}}</th>
                </tr></thead>
                <tbody><tr>
                    <td>{{query.username}}</td>
                    <td v-for="h in pivots.deliveryTwdOffline.headers" :key="h">{{pivots.deliveryTwdOffline.cells[h]}}</td>
                </tr></tbody>
            </table>
        </section>

        <section v-if="pivots.deliveryRmbStore.headers.length" style="margin-bottom:20px;">
            <h2 class="xtitle">{{msg('店配派件费')}} (RMB)</h2>
            <table class="xtable">
                <thead><tr>
                    <th>{{msg('结算账号')}}</th>
                    <th v-for="h in pivots.deliveryRmbStore.headers" :key="h">{{h}}</th>
                </tr></thead>
                <tbody><tr>
                    <td>{{query.username}}</td>
                    <td v-for="h in pivots.deliveryRmbStore.headers" :key="h">{{pivots.deliveryRmbStore.cells[h]}}</td>
                </tr></tbody>
            </table>
        </section>

        <section v-if="pivots.deliveryRmbOffline.headers.length" style="margin-bottom:20px;">
            <h2 class="xtitle">{{msg('线下派件费')}} (RMB)</h2>
            <table class="xtable">
                <thead><tr>
                    <th>{{msg('结算账号')}}</th>
                    <th v-for="h in pivots.deliveryRmbOffline.headers" :key="h">{{h}}</th>
                </tr></thead>
                <tbody><tr>
                    <td>{{query.username}}</td>
                    <td v-for="h in pivots.deliveryRmbOffline.headers" :key="h">{{pivots.deliveryRmbOffline.cells[h]}}</td>
                </tr></tbody>
            </table>
        </section>

        <!-- 打包费 -->
        <section v-if="pivots.pkg.headers.length" style="margin-bottom:20px;">
            <h2 class="xtitle">{{msg('打包费')}}</h2>
            <table class="xtable">
                <thead><tr>
                    <th>{{msg('结算账号')}}</th>
                    <th v-for="h in pivots.pkg.headers" :key="h">{{h}}</th>
                </tr></thead>
                <tbody><tr>
                    <td>{{query.username}}</td>
                    <td v-for="h in pivots.pkg.headers" :key="h">{{pivots.pkg.cells[h]}}</td>
                </tr></tbody>
            </table>
        </section>

        <!-- 偏远附加费 -->
        <section v-if="pivots.surcharge.headers.length" style="margin-bottom:20px;">
            <h2 class="xtitle">{{msg('偏远附加费')}}</h2>
            <table class="xtable">
                <thead><tr>
                    <th>{{msg('结算账号')}}</th>
                    <th v-for="h in pivots.surcharge.headers" :key="h">{{h}}</th>
                </tr></thead>
                <tbody><tr>
                    <td>{{query.username}}</td>
                    <td v-for="h in pivots.surcharge.headers" :key="h">{{pivots.surcharge.cells[h]}}</td>
                </tr></tbody>
            </table>
        </section>

        <!-- 代收手续费 2张 -->
        <section v-if="pivots.handlingSea.headers.length" style="margin-bottom:20px;">
            <h2 class="xtitle">{{msg('海快代收手续费')}}</h2>
            <table class="xtable">
                <thead><tr>
                    <th>{{msg('结算账号')}}</th>
                    <th v-for="h in pivots.handlingSea.headers" :key="h">{{h}}</th>
                </tr></thead>
                <tbody><tr>
                    <td>{{query.username}}</td>
                    <td v-for="h in pivots.handlingSea.headers" :key="h">{{pivots.handlingSea.cells[h]}}</td>
                </tr></tbody>
            </table>
        </section>

        <section v-if="pivots.handlingNormal.headers.length" style="margin-bottom:20px;">
            <h2 class="xtitle">{{msg('非海快代收手续费')}}</h2>
            <table class="xtable">
                <thead><tr>
                    <th>{{msg('结算账号')}}</th>
                    <th v-for="h in pivots.handlingNormal.headers" :key="h">{{h}}</th>
                </tr></thead>
                <tbody><tr>
                    <td>{{query.username}}</td>
                    <td v-for="h in pivots.handlingNormal.headers" :key="h">{{pivots.handlingNormal.cells[h]}}</td>
                </tr></tbody>
            </table>
        </section>

        <!-- 汇率差/重量差：1 行 2 列 -->
        <!-- <section v-if="rateDif!==null || weightDif!==null" style="margin-bottom:20px;">
            <h2 class="xtitle">{{msg('汇率差 / 重量差')}}</h2>
            <table class="xtable xrate-table">
                <thead><tr>
                    <th>{{msg('结算账号')}}</th>
                    <th>{{msg('汇率差')}}</th>
                    <th>{{msg('重量差')}}</th>
                </tr></thead>
                <tbody><tr>
                    <td>{{query.username}}</td>
                    <td>{{rateDif===null?'-':rateDif}}</td>
                    <td>{{weightDif===null?'-':weightDif}}</td>
                </tr></tbody>
            </table>
        </section> -->

        <section v-if="!hasAny">
            <el-empty :description="msg('暂无报价数据')"></el-empty>
        </section>

                    </div><!-- min-width 1920 -->
                </div><!-- table-wrap -->
    </div><!-- ctrl-wrap -->
</template>
<script>
export default {
    name: 'OfferMy',
    data(){
        let user = JSON.parse(localStorage.getItem("user") || "{}");
        return {
            offer: null,
            query: {
                username: (user && user.username)? user.username : '',
            },
            raw: {
                freights: [], deliveries: [], packages: [], surcharges: [],
                handlings: [], rateDifs: [], weightDifs: [],
            },
            pivots: this.emptyPivots(),
            rateDif: null,
            weightDif: null,
        };
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 240;
            }
        },
        hasAny(){
            return this.pivots.freight.headers.length
                || this.pivots.deliveryTwdStore.headers.length
                || this.pivots.deliveryTwdOffline.headers.length
                || this.pivots.deliveryRmbStore.headers.length
                || this.pivots.deliveryRmbOffline.headers.length
                || this.pivots.pkg.headers.length
                || this.pivots.surcharge.headers.length
                || this.pivots.handlingSea.headers.length
                || this.pivots.handlingNormal.headers.length
                || this.rateDif!==null
                || this.weightDif!==null;
        }
    },
    mounted(){
        if(this.query.username) this.load();
    },
    methods: {
        emptyPivots(){
            return {
                freight:             { headers:[], cells:{} },
                deliveryTwdStore:    { headers:[], cells:{} },
                deliveryTwdOffline:  { headers:[], cells:{} },
                deliveryRmbStore:    { headers:[], cells:{} },
                deliveryRmbOffline:  { headers:[], cells:{} },
                pkg:                 { headers:[], cells:{} },
                surcharge:           { headers:[], cells:{} },
                handlingSea:         { headers:[], cells:{} },
                handlingNormal:      { headers:[], cells:{} },
            };
        },
        // 金额统一从分(×100)转元
        amt(cent){
            if(cent===null || cent===undefined || cent==='') return "0.00";
            var v = Number(cent);
            if(isNaN(v)) return "0.00";
            return (v/100).toFixed(2);
        },
        // 行转列：rows 中取 colField 作列，按列出现顺序 headers；单元格 = rows 中匹配第一条的 amtField 转元
        //   可选 filters：{k1:v1, k2:v2}，只保留 rows 中全部命中的子集
        pivot(rows, colField, amtField, filters){
            if(!rows || !rows.length) return {headers:[], cells:{}};
            filters = filters || {};
            var seen = {};
            var headers = [];
            var cells = {};
            for(var i=0;i<rows.length;i++){
                var r = rows[i];
                var ok = true;
                for(var k in filters){
                    if(String(r[k]) !== String(filters[k])){ ok=false; break; }
                }
                if(!ok) continue;
                var col = r[colField];
                if(col===null||col===undefined||col==='') continue;
                if(!Object.prototype.hasOwnProperty.call(seen, col)){
                    seen[col] = 1;
                    headers.push(col);
                }
                cells[col] = this.amt(r[amtField]);
            }
            return { headers: headers, cells: cells };
        },
        load(){
            var u = (this.query.username||'').trim();
            var that = this;
            that.offer = null;
            that.pivots = that.emptyPivots();
            that.rateDif = null;
            that.weightDif = null;
            if(!u) return;
            this.$axios.get(this.$kit.api.financeOffer.myOffer, {params:{ username: u }})
                .then(function(res){
                    if(!res || !res.status) return;
                    var d = res.data || {};
                    that.offer = d.offer;

                    // JFinal Record 经 Jackson 序列化会包一层 columns；这里统一拆包
                    var _unwrap = function(arr){
                        if(!arr || !arr.length) return [];
                        if(arr[0] && Object.prototype.hasOwnProperty.call(arr[0],"columns")){
                            return arr.map(function(e){ return e.columns || {}; });
                        }
                        return arr;
                    };

                    that.raw.freights    = _unwrap(d.freights);
                    that.raw.deliveries  = _unwrap(d.deliveries);
                    that.raw.packages    = _unwrap(d.packages);
                    that.raw.surcharges  = _unwrap(d.surcharges);
                    that.raw.handlings   = _unwrap(d.handlings);
                    that.raw.rateDifs    = _unwrap(d.rateDifs);
                    that.raw.weightDifs  = _unwrap(d.weightDifs);

                    that.pivots.freight            = that.pivot(that.raw.freights,    'type',       'amount');
                    that.pivots.deliveryTwdStore   = that.pivot(that.raw.deliveries,  'exp_company','amount', {order_origin:0, currency:1});
                    that.pivots.deliveryTwdOffline = that.pivot(that.raw.deliveries,  'exp_company','amount', {order_origin:1, currency:1});
                    that.pivots.deliveryRmbStore   = that.pivot(that.raw.deliveries,  'exp_company','amount', {order_origin:0, currency:0});
                    that.pivots.deliveryRmbOffline = that.pivot(that.raw.deliveries,  'exp_company','amount', {order_origin:1, currency:0});
                    that.pivots.pkg                = that.pivot(that.raw.packages,    'exp_company','amount');
                    that.pivots.surcharge          = that.pivot(that.raw.surcharges,  'area',       'amount');

                    // 代收手续费列名 = `rangeMin-rangeMax`（区间值存库单位为分，÷100 转元展示），先合成
                    var hRows = that.raw.handlings.map(function(h){
                        return Object.assign({}, h, { rangeLabel: ((h.range_min!=null?h.range_min:0)/100)+'-'+((h.range_max!=null?h.range_max:0)/100) });
                    });
                    that.pivots.handlingSea    = that.pivot(hRows, 'rangeLabel', 'amount', {type:0});
                    that.pivots.handlingNormal = that.pivot(hRows, 'rangeLabel', 'amount', {type:1});

                    that.rateDif   = that.raw.rateDifs.length   ? that.amt(that.raw.rateDifs[0].rate_dif)   : null;
                    that.weightDif = that.raw.weightDifs.length ? that.amt(that.raw.weightDifs[0].weight_dif) : null;
                });
        }
    }
}
</script>
<style scoped lang="scss">
.xtitle{font-size:14px; margin:14px 0 6px; color:#303133;}
.xlabel{color:#606266;}
.xtext{color:#303133;}
.xsmall{color:#909399; font-size:12px; margin-left:6px;}
table.xtable{border-collapse: collapse; text-align: center; min-width:100%; width:auto; table-layout:auto; font-size:12px;}
.xtable tr{border-top:1px solid #c0c6d4; border-left:1px solid #c0c6d4;}
.xtable th{ background:#f5f7fa; white-space:nowrap; font-size:12px;}
.xtable td, .xtable th{border-right:1px solid #c0c6d4; border-bottom:1px solid #c0c6d4; padding:2px 8px; white-space:nowrap;}
table.xtable.xrate-table{min-width:auto;}
</style>
